import {categoryColor} from 'utils/Helper';

export default theme => ({
  root: {
    paddingTop: 15,
    paddingLeft: 10,
    paddingRight: 10,
    display: 'flex',
    marginRight: 20,
    justifyContent: 'center',
    lineHeight: 1.6,
    fontSize: 14,
  },
  item: {
    display: 'block',
    '& a': {
      display: 'block',
      padding: '3px 10px',
      borderRadius: 3,
      color: categoryColor('category', 'primary', 500, '#0a0a0a'),
    },
    '& a:hover': {
      background: '#eee'
    }
  },
  current: {
    '& a': {
      background: categoryColor('category', 'primary', 500, '#2ba6cb'),
      color: '#fff !important',
    },
    '& a:hover': {
      background: categoryColor('category', 'primary', 500, '#2ba6cb'),
    }
  },
  disabled: {
    color: '#cacaca',
    padding: '3px 10px',
  }
});